enum TEFeedbackSignal {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Helper = 'helper',
}

export default TEFeedbackSignal;
